/**
 * F-31 paste-URL detection — PURE logic (no DOM, no Yjs). Decides whether the
 * pasted `text/plain` is a SINGLE http(s) URL that should become a link-card
 * element (docs/02 F-31). Anything else — multi-line text, a `mailto:` / other
 * non-http(s) scheme, tabular TSV, plain non-URL text — returns null so the
 * paste falls through to the grid's existing TSV paste handler unchanged (F-16).
 */

/**
 * The single http(s) URL a pasted string represents, or null when it is not a
 * lone http(s) URL. Trims surrounding whitespace; rejects any string with
 * interior whitespace (a space / newline means multi-line or tabular text, not
 * one URL) and any scheme other than http/https (`mailto:`, `ftp:`, …).
 */
export function singleHttpUrl(text: string): URL | null {
  const trimmed = text.trim();
  if (trimmed.length === 0) return null;
  // A single URL has no interior whitespace; any space/tab/newline means this
  // is multi-line or tabular text and belongs to the TSV paste path.
  if (/\s/.test(trimmed)) return null;
  let url: URL;
  try {
    url = new URL(trimmed);
  } catch {
    return null; // not a parseable absolute URL (e.g. a bare "example.com")
  }
  if (url.protocol !== "http:" && url.protocol !== "https:") return null;
  return url;
}
